// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","396":"93f32141","455":"7d4c2ee1","977":"c7d6623c"}[chunkId] + ".chunk.js";
};